/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CustomFieldDestroyTask } from '../models';
/**
 * CustomFieldDestroyTaskApi - axios parameter creator
 * @export
 */
export const CustomFieldDestroyTaskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * カスタム情報削除タスク取得API
         * @summary カスタム情報削除タスク取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFieldDestroyTasks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/custom_field_destroy_tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * カスタム情報削除タスクconfirm API
         * @summary カスタム情報削除タスクconfirm API
         * @param {number} customFieldDestroyTaskId カスタム情報削除タスクのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomFieldDestroyTask: async (customFieldDestroyTaskId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFieldDestroyTaskId' is not null or undefined
            assertParamExists('putCustomFieldDestroyTask', 'customFieldDestroyTaskId', customFieldDestroyTaskId)
            const localVarPath = `/api/user/custom_field_destroy_tasks/{customFieldDestroyTaskId}`
                .replace(`{${"customFieldDestroyTaskId"}}`, encodeURIComponent(String(customFieldDestroyTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomFieldDestroyTaskApi - functional programming interface
 * @export
 */
export const CustomFieldDestroyTaskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomFieldDestroyTaskApiAxiosParamCreator(configuration)
    return {
        /**
         * カスタム情報削除タスク取得API
         * @summary カスタム情報削除タスク取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomFieldDestroyTasks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomFieldDestroyTask>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomFieldDestroyTasks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * カスタム情報削除タスクconfirm API
         * @summary カスタム情報削除タスクconfirm API
         * @param {number} customFieldDestroyTaskId カスタム情報削除タスクのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomFieldDestroyTask(customFieldDestroyTaskId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomFieldDestroyTask(customFieldDestroyTaskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomFieldDestroyTaskApi - factory interface
 * @export
 */
export const CustomFieldDestroyTaskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomFieldDestroyTaskApiFp(configuration)
    return {
        /**
         * カスタム情報削除タスク取得API
         * @summary カスタム情報削除タスク取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFieldDestroyTasks(options?: any): AxiosPromise<Array<CustomFieldDestroyTask>> {
            return localVarFp.getCustomFieldDestroyTasks(options).then((request) => request(axios, basePath));
        },
        /**
         * カスタム情報削除タスクconfirm API
         * @summary カスタム情報削除タスクconfirm API
         * @param {number} customFieldDestroyTaskId カスタム情報削除タスクのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomFieldDestroyTask(customFieldDestroyTaskId: number, options?: any): AxiosPromise<void> {
            return localVarFp.putCustomFieldDestroyTask(customFieldDestroyTaskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomFieldDestroyTaskApi - interface
 * @export
 * @interface CustomFieldDestroyTaskApi
 */
export interface CustomFieldDestroyTaskApiInterface {
    /**
     * カスタム情報削除タスク取得API
     * @summary カスタム情報削除タスク取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDestroyTaskApiInterface
     */
    getCustomFieldDestroyTasks(options?: AxiosRequestConfig): AxiosPromise<Array<CustomFieldDestroyTask>>;

    /**
     * カスタム情報削除タスクconfirm API
     * @summary カスタム情報削除タスクconfirm API
     * @param {number} customFieldDestroyTaskId カスタム情報削除タスクのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDestroyTaskApiInterface
     */
    putCustomFieldDestroyTask(customFieldDestroyTaskId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putCustomFieldDestroyTask operation in CustomFieldDestroyTaskApi.
 * @export
 * @interface CustomFieldDestroyTaskApiPutCustomFieldDestroyTaskRequest
 */
export interface CustomFieldDestroyTaskApiPutCustomFieldDestroyTaskRequest {
    /**
     * カスタム情報削除タスクのID
     * @type {number}
     * @memberof CustomFieldDestroyTaskApiPutCustomFieldDestroyTask
     */
    readonly customFieldDestroyTaskId: number
}

/**
 * CustomFieldDestroyTaskApi - object-oriented interface
 * @export
 * @class CustomFieldDestroyTaskApi
 * @extends {BaseAPI}
 */
export class CustomFieldDestroyTaskApi extends BaseAPI implements CustomFieldDestroyTaskApiInterface {
    /**
     * カスタム情報削除タスク取得API
     * @summary カスタム情報削除タスク取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDestroyTaskApi
     */
    public getCustomFieldDestroyTasks(options?: AxiosRequestConfig) {
        return CustomFieldDestroyTaskApiFp(this.configuration).getCustomFieldDestroyTasks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * カスタム情報削除タスクconfirm API
     * @summary カスタム情報削除タスクconfirm API
     * @param {CustomFieldDestroyTaskApiPutCustomFieldDestroyTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDestroyTaskApi
     */
    public putCustomFieldDestroyTask(requestParameters: CustomFieldDestroyTaskApiPutCustomFieldDestroyTaskRequest, options?: AxiosRequestConfig) {
        return CustomFieldDestroyTaskApiFp(this.configuration).putCustomFieldDestroyTask(requestParameters.customFieldDestroyTaskId, options).then((request) => request(this.axios, this.basePath));
    }
}
